interface TabContainerProps {
  size?: 'md' | 'lg';
  underline?: boolean;
  children: React.ReactNode;
}

const Container = ({
  children,
  size = 'md',
  underline = false,
}: TabContainerProps) => {
  let defaultClass = 'inline-flex text-sm w-full';

  const underlineClass = underline ? 'border-b border-trueGray-400' : '';

  const sizes = {
    md: 'text-sm',
    lg: 'text-base',
  };

  const sizeClass = sizes[size];

  return (
    <div className={`${defaultClass} ${underlineClass} ${sizeClass}`}>
      {children}
    </div>
  );
};

interface TabProps {
  onClick?: () => void;
  children: React.ReactNode;
  addonLeft?: React.ReactNode;
  addonRight?: React.ReactNode;
  variant?: 'default' | 'active' | 'disabled';
}

const Tab = ({
  children,
  onClick,
  addonLeft,
  addonRight,
  variant = 'default',
}: TabProps) => {
  const variantStyles = {
    disabled: 'text-warmGray-500 cursor-not-allowed',
    active: 'text-primary-500 border-b-2 border-primary-500 cursor-pointer',
    default:
      'text-warmGray-900 cursor-pointer hover:text-primary-500 hover:border-b-2 hover:border-primary-500',
  };

  const styles = variantStyles[variant];

  return (
    <span
      onClick={onClick}
      className={`select-none text-base font-normal p-2 ${styles}`}
    >
      {addonLeft && <div className="mr-2">{addonLeft}</div>}
      {children}
      {addonRight && <div className="ml-2">{addonRight}</div>}
    </span>
  );
};

const Tabs = {
  Tab,
  Container,
};

export default Tabs;
